module.exports = "<div class=\"page-simulated\">\n  <display-system uoid=\"{{vm.uoid}}\"></display-system>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/pages/simulated/simulated.html
// module id = 677
// module chunks = 0